import React, { useEffect, useMemo, useState } from "react";
import { Button, Modal, ModalBody, ModalFooter } from "reactstrap";
import { getCookie } from "../jwt/_helpers/cookie";
import { stripeSubscriptionService } from "../jwt/_services/stripeSubscription.service";
import CurrentSubscriptionDetails from "../views/stripeSubscription/currentSubscriptionDetails";
import {
  enrichSubscriptionDetails,
  getActiveTenantSubscription,
  getSubscriptionStatusBadgeConfig,
} from "../views/stripeSubscription/planUtils";
import "../views/stripeSubscription/tenantCustomerPlans.css";

const SubUserSubscriptionModal = ({ isOpen, subUser, onClose }) => {
  const [plans, setPlans] = useState([]);

  useEffect(() => {
    if (!isOpen) {
      return undefined;
    }

    let isMounted = true;
    const token = getCookie("token");

    stripeSubscriptionService
      .listPublicPlansCached(token)
      .then((items) => {
        if (isMounted) {
          setPlans(items);
        }
      })
      .catch(() => {
        if (isMounted) {
          setPlans([]);
        }
      });

    return () => {
      isMounted = false;
    };
  }, [isOpen]);

  const subscription = useMemo(() => {
    if (!subUser) {
      return null;
    }

    return enrichSubscriptionDetails(
      getActiveTenantSubscription(subUser),
      plans
    );
  }, [subUser, plans]);

  const statusBadge = subscription?.status
    ? getSubscriptionStatusBadgeConfig(subscription.status)
    : null;

  if (!subUser) {
    return null;
  }

  const hasPlan = !!(subscription?.plan_name || subUser.tenant_subscription_plan);
  const modalTitle = subUser.friendly_name
    ? `Subscription plan - ${subUser.friendly_name}`
    : "Subscription plan";

  return (
    <Modal isOpen={isOpen} toggle={onClose} centered size="lg">
      <ModalBody>
        {!hasPlan ? (
          <>
            <h4 className="mb-3">{modalTitle}</h4>
            <p className="mb-0 text-muted">This sub-user is not on a subscription plan.</p>
          </>
        ) : (
          <div className="stripe-subscription-modal-content">
            <div className="stripe-plans-current-card-header mb-3">
              <h4 className="mb-0">{modalTitle}</h4>
              {statusBadge && (
                <span className={`stripe-subscription-status-badge ${statusBadge.className}`}>
                  {statusBadge.label}
                </span>
              )}
            </div>
            <CurrentSubscriptionDetails subscription={subscription} user={subUser} />
          </div>
        )}
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={onClose}>
          Close
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default SubUserSubscriptionModal;
